import { render, staticRenderFns } from "./NodeSignIn.vue?vue&type=template&id=1f20ed80&scoped=true&"
import script from "./NodeSignIn.vue?vue&type=script&lang=js&"
export * from "./NodeSignIn.vue?vue&type=script&lang=js&"
import style0 from "./NodeSignIn.vue?vue&type=style&index=0&id=1f20ed80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f20ed80",
  null
  
)

export default component.exports